import { Component, Input, OnInit } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';

import { BetBuilderMarket } from '../../model/bet-builder.model';
import { BetBuilderMarketCardComponent } from './bet-builder-market-card.component';

@Component({
    selector: 'ms-bet-builder-market-card-list',
    templateUrl: './bet-builder-market-card-list.component.html',
    imports: [BetBuilderMarketCardComponent],
})
export class BetBuilderMarketCardListComponent implements OnInit {
    @Input() event: EventModel;
    @Input() markets: BetBuilderMarket[];
    @Input() fixtureId: string;

    showName: boolean;

    ngOnInit(): void {
        this.showName = this.markets && this.markets.length > 1;
    }
}
